
<section
  id="followup"
  class="l-followup"
>
  <div class="o-container">
    <h2 class="title l-followup__title">
      compra feita, agora é só acompanhar o pedido
    </h2>

    <div class="l-followup__wrapper">
      <figure class="l-followup__figure l-figure">
        <picture>
          <img
            class="l-image l-followup__image"
            :src="
              require('@@/assets/images/landing-pages/how-to-buy/follow-up/steps.png')
            "
            :srcset="`
              ${require('@@/assets/images/landing-pages/how-to-buy/follow-up/steps.png')},
              ${require('@@/assets/images/landing-pages/how-to-buy/follow-up/steps@2x.png')} 2x
            `"
            alt="Imagem contém ícones ilustrando os passos de realizar a compra,
            aprovação, empacotamento, transporte e conclusão do pedido."
          >
        </picture>
      </figure>
    </div>

    <p class="l-followup__description">
      você pode acompanhar a sua compra pelo site, pelo app e também pelos emails.
    </p>
  </div>
</section>
